var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MemberOrder"},[_c('div',{staticClass:"scanCode"},[_c('h4',[_vm._v("扫码打开"+_vm._s(_vm.isCzScenes ? '成就非凡' : '名师天团')+"APP查看订单")]),_c('p',[_vm._v("请在【APP-我的-我的订单】查看")]),_c('img',{staticClass:"scanCodeImg",attrs:{"src":_vm.isCzScenes
          ? 'https://cdn.yuaiweiwu.com/fe/imgs/9a504430-0532-11ef-98c0-ad176ce97a45-cjff.png'
          : 'https://cdn.yuaiweiwu.com/fe/imgs/96bae870-0532-11ef-98c0-ad176ce97a45-mstt.png'}}),_c('p',[_vm._v("使用微信扫码")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }